import classes from './styles.module.css';


function Spinner() {
    return (
        <span className={classes.loader}></span>
    )
}

export default Spinner